"use client";
/**
 * @description: 基于mui简单的二次封装
 * @author: zhouyh
 * @time: 2023/8/10 15:18
 */
import { SliderThumb, Slider, Box, styled } from "@mui/material";
import { SyntheticEvent } from "react";
import variable from "../styles/variable.module.scss";
import stl from "../styles/slider.module.scss";

type FmSliderProps = {
    width: number;
    value: Array<number> | number;
    disabled?: boolean;
    max?: number;
    min?: number;
    // 利于视障用户的标签文本，应于值的数组长度对应
    ariaLabel?: string | Array<string>;
    // 参数：事件，值（从左到右），节点（从左到右，从0开始）
    onChange: (
        event: Event | SyntheticEvent<Element, Event>,
        newValue: number | number[],
        activeThumb: number,
    ) => void;
    onChangeCommitted: (
        event: Event | SyntheticEvent<Element, Event>,
        value: number | number[],
    ) => void;
};

const AirbnbSlider = styled(Slider)(({ theme }) => ({
    color: variable.main,
    height: 3,
    padding: "13px 0",
    "& .MuiSlider-thumb": {
        height: "0.4rem",
        width: "0.4rem",
        backgroundColor: "#fff",
        border: "3px solid rgba(38, 186, 255, 0.72)",
        "&:hover": {
            boxShadow: "0 0 0 0.1rem rgba(58, 133, 137, 0.16)",
        },
        "&.Mui-active": {
            boxShadow: "0px 0px 0px 0.2rem rgba(25, 118, 210, 0.16)",
        },
    },
    "& .MuiSlider-track": {
        height: 2,
    },
    "& .MuiSlider-rail": {
        color: "#cccccc",
        opacity: 1,
        height: 3,
    },
}));

interface AirbnbThumbComponentProps extends React.HTMLAttributes<unknown> {}

function AirbnbThumbComponent(props: AirbnbThumbComponentProps) {
    const { children, ...other } = props;
    return <SliderThumb {...other}>{children}</SliderThumb>;
}

export default function FmSlider(props: Readonly<FmSliderProps>) {
    const {
        width,
        value,
        onChange,
        onChangeCommitted,
        disabled,
        ariaLabel,
        max = 100,
        min = 0,
    } = props;
    return (
        <Box sx={{ width: width }}>
            <AirbnbSlider
                classes={{
                    thumb: stl["thumb"],
                }}
                slots={{ thumb: AirbnbThumbComponent }}
                getAriaLabel={(index: number) => {
                    if (!ariaLabel) return "";
                    if (Array.isArray(ariaLabel)) {
                        return ariaLabel[index];
                    } else {
                        return ariaLabel;
                    }
                }}
                onChangeCommitted={onChangeCommitted}
                min={min}
                max={max}
                disabled={disabled}
                defaultValue={[0, 100]}
                value={value}
                onChange={onChange}
            />
        </Box>
    );
}
